export default "__VITE_ASSET__43fabdc3__"